import { render } from "./DownloadReportModal.vue?vue&type=template&id=3f67e884&ts=true"
import script from "./DownloadReportModal.vue?vue&type=script&lang=ts"
export * from "./DownloadReportModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QRadio,QSeparator,QCheckbox});
